import React from 'react'

const TabItem = ({selected, text, icon, className, onClick = () => {}, accent, uppercase, embed, small}) => {
  const accented = accent ? 'font-accent' : ''
  const uppercaseClass = uppercase ? 'uppercase' : ''

  return (
    <div
      className={`cursor-pointer flex border-primary ${className} ${selected === text ? 'border-b-2 lg:border-b-4' : 'opacity-50'}`}
      onClick={() => onClick(text)}
    >
      {
        icon &&
        <div className="hidden lg:block mr-2">
          {icon}
        </div>
      }
      <p className={`font-bold text-center lg:text-left ${embed ? 'text-xs' : 'text-sm'} ${small ? 'lg:text-sm' : 'lg:text-base'} ${accented} ${uppercaseClass}`}>
        {text}
      </p>
    </div>
  )
}

export { TabItem }
